import { IRouterChangeData } from './Interfaces/Utils.interface';

const routerChangeDefaults: IRouterChangeData = {
  eventType: 'pagechange',
  newPageName: ''
};

export const RouterChange = (newPageName = '') => {
  return new CustomEvent('routeChange', {
    detail: {
      ...routerChangeDefaults,
      newPageName
    }
  });
};

export const dispatchCustomEvent = (event: CustomEvent) => {
  document.dispatchEvent(event);
};
